import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const get = async ({ complaintId = '', twoFactorAuthToken, ...params }) => {
  const config = { params }

  if (twoFactorAuthToken) {
    config.headers = {
      'X-Complaints-2FA-Token': twoFactorAuthToken,
    }
  }

  return await dponetAPI.get(`/complaints/${complaintId}`, config)
}

const registerResponsible = async ({
  complaintId = '',
  twoFactorAuthToken,
  ...params
}) => {
  const config = {}

  if (twoFactorAuthToken) {
    config.headers = {
      'X-Complaints-2FA-Token': twoFactorAuthToken,
    }
  }

  return await dponetAPI.put(
    `/complaints/${complaintId}/responsible`,
    params,
    config,
  )
}

const activateComplaints = async (data) => {
  return await dponetAPI.put(`/complaints/activate_complaints`, data)
}

const logs = async ({ complaintId, twoFactorAuthToken }) => {
  const config = {}

  if (twoFactorAuthToken) {
    config.headers = {
      'X-Complaints-2FA-Token': twoFactorAuthToken,
    }
  }

  return await dponetAPI.get(`/complaints/${complaintId}/logs`, config)
}

const lastAccess = async ({ complaintId, twoFactorAuthToken, ...params }) => {
  const config = {}

  if (twoFactorAuthToken) {
    config.headers = {
      'X-Complaints-2FA-Token': twoFactorAuthToken,
    }
  }

  return await dponetAPI.patch(
    `/complaints/${complaintId}/last_access`,
    params,
    config,
  )
}

export default {
  activateComplaints,
  get,
  lastAccess,
  logs,
  registerResponsible,
}
